import React from 'react';
// import InfoIcon from '../../Assets/infoIcon.png';
import {
    Container,
    FormControl,
    Col,
    Button,
    Popover,
    OverlayTrigger,
} from 'react-bootstrap';

const Questionaire = (props) => {
    const popover = (
        <Popover id='popover'>
            <Popover.Content>{props.msgText}</Popover.Content>
        </Popover>
    );

    return (
        <>
            <FormControl
                defaultValue={props.query}
                placeholder={props.placeholderTxt}
                className='input-field margin20-width60'
                as='textarea'
                rows={8}
                onChange={(text) => props.onChangeQuery(text)}
            />
            {/* <div className='d-flex justify-content-end m-1 mb-3'>
                <OverlayTrigger
                    trigger='hover'
                    placement='left'
                    overlay={popover}
                >
                    <img src={InfoIcon} width='20' height='20' />
                </OverlayTrigger>
            </div> */}
        </>
    );
};

export default Questionaire;
